module.exports = __webpack_public_path__ + "static/media/day-night.c5865937.svg";